module.exports = __webpack_public_path__ + "static/media/astri_cahyanti.e9aa49a9.jpg";